import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page" dir="rtl">
      {/* Navigation */}
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="nav-logo">
            <span className="logo-icon">📋</span>
            <span className="logo-text">Ktav Kamuyot</span>
          </div>
          <div className="nav-links">
            <a href="#features" className="nav-link">
              תכונות
            </a>
            <a href="#how-it-works" className="nav-link">
              איך זה עובד
            </a>
            <button className="nav-login" onClick={() => navigate('/login')}>
              התחברות
            </button>
            <button className="nav-signup" onClick={() => navigate('/signup')}>
              הרשמה חינם
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              נהל את פרויקט השיפוץ שלך
              <span className="hero-highlight"> בקלות ובשקיפות</span>
            </h1>
            <p className="hero-subtitle">
              Ktav Kamuyot היא פלטפורמה חכמה לניהול פרויקטי בנייה ושיפוצים. עקוב אחר התקציב, לוח
              הזמנים, והתקדמות העבודה - הכל במקום אחד.
            </p>
            <div className="hero-cta">
              <button className="cta-primary" onClick={() => navigate('/signup')}>
                התחל בחינם
              </button>
              <button className="cta-secondary" onClick={() => navigate('/login')}>
                יש לי חשבון
              </button>
            </div>
            <p className="hero-note">✓ ללא צורך בכרטיס אשראי &nbsp; ✓ התחל תוך דקות</p>
          </div>
          <div className="hero-visual">
            <div className="hero-mockup">
              <div className="mockup-header">
                <div className="mockup-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="mockup-content">
                <div className="mockup-sidebar"></div>
                <div className="mockup-main">
                  <div className="mockup-card"></div>
                  <div className="mockup-card"></div>
                  <div className="mockup-card small"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <div className="section-container">
          <h2 className="section-title">למה Ktav Kamuyot?</h2>
          <p className="section-subtitle">כל הכלים שאתה צריך לניהול פרויקט מוצלח</p>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3 className="feature-title">ניהול תקציב</h3>
              <p className="feature-description">
                עקוב אחר הוצאות בזמן אמת, קבל התראות על חריגות, ושמור על התקציב שלך
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📅</div>
              <h3 className="feature-title">לוח זמנים</h3>
              <p className="feature-description">
                תכנן את שלבי הפרויקט, עקוב אחר אבני דרך, וקבל תמונה ברורה של ההתקדמות
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🏠</div>
              <h3 className="feature-title">ניהול חללים</h3>
              <p className="feature-description">
                ארגן את הפרויקט לפי חדרים וחללים, עם כל הפרטים והפריטים הרלוונטיים
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📋</div>
              <h3 className="feature-title">כתב כמויות</h3>
              <p className="feature-description">
                צור כתב כמויות מקצועי אוטומטית, מוכן לשליחה לקבלנים ולקבלת הצעות מחיר
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3 className="feature-title">שיתוף פעולה</h3>
              <p className="feature-description">
                שתף את הפרויקט עם בני משפחה, מעצבים, וקבלנים - כולם מעודכנים
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3 className="feature-title">דוחות ותובנות</h3>
              <p className="feature-description">
                קבל תמונה מלאה של מצב הפרויקט עם דוחות ויזואליים וברורים
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-section">
        <div className="section-container">
          <h2 className="section-title">איך זה עובד?</h2>
          <p className="section-subtitle">שלושה צעדים פשוטים להתחלה</p>

          <div className="steps-container">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3 className="step-title">צור פרויקט</h3>
              <p className="step-description">
                הירשם בחינם והגדר את פרטי הפרויקט שלך - כתובת, תקציב, ולוח זמנים
              </p>
            </div>

            <div className="step-connector"></div>

            <div className="step-card">
              <div className="step-number">2</div>
              <h3 className="step-title">הגדר חללים ופריטים</h3>
              <p className="step-description">
                הוסף את החדרים והחללים בפרויקט, ובחר את הפריטים והגימורים הרצויים
              </p>
            </div>

            <div className="step-connector"></div>

            <div className="step-card">
              <div className="step-number">3</div>
              <h3 className="step-title">נהל ועקוב</h3>
              <p className="step-description">
                עקוב אחר ההתקדמות, נהל את התקציב, ושמור על הפרויקט במסלול
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="section-container">
          <h2 className="cta-title">מוכן להתחיל?</h2>
          <p className="cta-subtitle">
            הצטרף לאלפי משתמשים שכבר מנהלים את פרויקטי השיפוץ שלהם בצורה חכמה
          </p>
          <button className="cta-button" onClick={() => navigate('/signup')}>
            התחל בחינם עכשיו
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-container">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon">📋</span>
              <span className="logo-text">Ktav Kamuyot</span>
            </div>
            <p className="footer-tagline">ניהול פרויקטי בנייה ושיפוצים בצורה חכמה</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>מוצר</h4>
              <a href="#features">תכונות</a>
              <a href="#how-it-works">איך זה עובד</a>
            </div>
            <div className="footer-column">
              <h4>חשבון</h4>
              <a href="/login">התחברות</a>
              <a href="/signup">הרשמה</a>
            </div>
            <div className="footer-column">
              <h4>משפטי</h4>
              <a href="/terms">תנאי שימוש</a>
              <a href="/privacy">מדיניות פרטיות</a>
            </div>
            <div className="footer-column">
              <h4>תמיכה</h4>
              <a href="mailto:ben@kamuyot.com">צור קשר</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Ktav Kamuyot. כל הזכויות שמורות.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
